import { Route, Routes } from 'react-router-dom';
import { NotFound } from 'common/components';
import Filter from './components/Filter';
import BulkUpload from './components/BulkUpload';
import { BulkUploadFilter } from 'api/dashboard';
import { t } from 'i18next';
import { useCallback, useState } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

const BulkUploadContainer = () => {

  const [isDashboardTab, setIsDashboardTab] = useState(false);

  const handleSubmit = useCallback(
    async (_payload: BulkUploadFilter) => {

    },
    [t]
  );

  const items: TabsProps['items'] = [
    {
      key: 'tabBulkUpload',
      label: 'Bulk Upload',
      children: (<><div><BulkUpload></BulkUpload></div></>),
    },
    {
      key: 'tabDashboard',
      label: 'Dashboard',
      children: (<> <Filter isLoading={false} onSubmit={handleSubmit} reloadByTabChange={isDashboardTab} /> </>),
    },
  ];

  function handleTabChange(activeKey: string): void {
    if (activeKey === "tabDashboard") {
      setIsDashboardTab(true);
    } else {
      setIsDashboardTab(false);
    }
  }

  return (
    <Routes>
      <Route
        element={
          <>
            <div className="container">
              <div className="submission-box">
                <h2>Bulk Upload</h2>
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12">
                    <div>
                      <Tabs
                        defaultActiveKey="tabBulkUpload"
                        centered
                        type="card"
                        items={items}
                        onChange={handleTabChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      >
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default BulkUploadContainer;
